import createErrorType from 'app/utils/createErrorType';

export class InvalidResultError extends createErrorType('InvalidResultError') {
}
